import type { i18n as I18nInstance } from 'i18next';
import { NODE_META } from '../components/workflow/nodeTypes';

const KNOWN_LANGS = ['zh', 'en', 'ja'] as const;

/** AI 生成工作流曾硬编码的中文别名，与 i18n 官方文案不一致，需视为「默认名称」随语言切换 */
const LEGACY_DEFAULT_LABELS: Record<string, readonly string[]> = {
  load_excel: ['加载数据'],
  filter: ['筛选数据'],
  sort: ['排序数据'],
  join: ['合并数据'],
  dedup: ['去除重复'],
  compute: ['计算列'],
  export: ['导出结果'],
};

/**
 * 画布 / 侧栏展示的节点名称：默认随当前语言走 i18n；仅当用户自定义名称时保留原文。
 * 空字符串表示「使用类型默认名」。
 */
export function getNodeDisplayLabel(
  nodeType: string,
  storedLabel: string | undefined,
  t: (key: string) => string,
  i18n: I18nInstance
): string {
  const meta = NODE_META[nodeType];
  if (!meta) {
    const raw = storedLabel?.trim() ?? '';
    return raw || nodeType;
  }

  const key = meta.labelKey;
  const defaultCurrent = t(key);
  const raw = storedLabel?.trim() ?? '';

  if (!raw) return defaultCurrent;
  if (raw === defaultCurrent) return defaultCurrent;

  for (const lng of KNOWN_LANGS) {
    const translated = i18n.getFixedT(lng)(key);
    if (raw === translated) return defaultCurrent;
  }

  const legacy = LEGACY_DEFAULT_LABELS[nodeType];
  if (legacy?.includes(raw)) return defaultCurrent;

  return raw;
}

/** 保存节点名称：与当前语言下的默认名一致时存空串，便于切换语言后仍显示翻译 */
export function normalizeNodeLabelForStore(
  nodeType: string,
  trimmedInput: string,
  t: (key: string) => string,
  i18n: I18nInstance
): string {
  const meta = NODE_META[nodeType];
  if (!meta) return trimmedInput;

  const key = meta.labelKey;
  if (trimmedInput === t(key)) return '';

  for (const lng of KNOWN_LANGS) {
    if (trimmedInput === i18n.getFixedT(lng)(key)) return '';
  }

  const legacy = LEGACY_DEFAULT_LABELS[nodeType];
  if (legacy?.includes(trimmedInput)) return '';

  return trimmedInput;
}
